var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#DC4243",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M5.994 0A5.998 5.998 0 0 0 0 6c0 3.312 2.683 6 5.994 6A6.004 6.004 0 0 0 12 6c0-3.312-2.688-6-6.006-6zM6 10.8a4.8 4.8 0 1 1 0-9.6 4.8 4.8 0 0 1 0 9.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.3 3h-.9v3.6l3.15 1.89L9 7.75 6.3 6.15z"
}))));
export default __webpack_public_path__ + "teg/media/timer-red.900962ab.svg";
export { SvgComponent as ReactComponent };